import { IPlanningRoute } from 'model/interfaces/IRoute';

export const isDriversSelected = (routes: IPlanningRoute[]) => {
	return routes.every(route => route.driver);

};